import React, { Component } from 'react';

import { Icon, Modal } from 'antd';

export default class Menu extends Component {
    constructor(props) {
        super(props);
        const session = JSON.parse(sessionStorage.session);
        const menu = (session.rules || []).map((item, i) => {
            if (i === 0) {
                return Object.assign({}, item, { expend: true, active: true })
            }

            return item;
        });

        this.draggable = false;

        this.startOffset = [220, 0];

        this.stopOffset = [220, 0];


        this.state = {
            menu
        }
    }

    componentDidMount() {
        document.addEventListener('mouseup', (event) => {
            if (this.draggable === true) {
                const offsetX = this.stopOffset[0] - this.startOffset[0];
                const offsetY = this.stopOffset[1] - this.startOffset[1];

                this.props.onMenuDragStop([this.props.Offset[0] + offsetX, 0]);
            }

            this.draggable = false;
        }, false);

        document.addEventListener('mousemove', (event) => {
            if (this.draggable === true) {
                this.stopOffset = [event.pageX, event.pageY]
                const offsetX = this.stopOffset[0] - this.startOffset[0];
                const offsetY = this.stopOffset[1] - this.startOffset[1];

                const draggable = this.refs.draggable;

                draggable.style.left = (this.props.Offset[0] + offsetX - 6) + 'px';

            }
        }, false);
    }

    expend(id) {
        const index = this.findRootMenuById(id);

        if (index !== -1) {
            const menu = this.state.menu.map((item, i) => {

                if (index === i) {
                    return Object.assign({}, item, {
                        active: true,
                        expend: true,
                        children: this.setMenuChildren(item.children || [], id)
                    })
                } else {
                    return Object.assign({}, item, {
                        active: false,
                        expend: false,
                    })
                }
            });

            this.setState({
                menu
            });

        } else {
            const menu = this.state.menu.map(item => {
                return Object.assign({}, item, {
                    children: this.setMenuChildren(item.children || [], id)
                });
            });

            this.setState({
                menu
            });
        }
    }

    setMenuChildren(menu, id) {
        return menu.map(item => {
            if (item.id === id) {
                return Object.assign({}, item, {
                    active: true,
                    expend: !item.expend,
                    children: this.setMenuChildren(item.children || [], id)
                });
            }
            return Object.assign({}, item, {
                active: false,
                children: this.setMenuChildren(item.children || [], id)
            });
        });
    }

    findRootMenuById(id) {
        const menu = this.state.menu;
        var index = -1;
        for (var i = 0; i < menu.length; i++) {
            const item = menu[i];
            if (item.id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    onMenuTab(item) {
        this.props.names.forEach(name => {
            if (item.url.indexOf(name) !== -1) {
                this.props.setCache({
                    [name]: true,
                });
                return;
            }
        });

        if (this.isUpdateMenu(item) !== -1) {
            this.props.insertOrUpdateTab(item);
        } else if (this.props.tabs.length < 8) {
            this.props.insertOrUpdateTab(item);
        } else {
            Modal.error({
                title: '提示：选项卡过多',
                content: (
                    <div>
                        <p>您的选项卡个数不能超出8个！</p>
                    </div>
                ),
                okText: '确定',
                onOk() { },
            });
        }
    }

    isUpdateMenu(item) {
        var index = -1;

        for (var i = 0; i < this.props.tabs.length; i++) {
            var tab = this.props.tabs[i];
            if (tab.url === item.url) {
                index = i;
                break;
            }
        }

        return index;
    }

    anchor(item, index, data) {

        const islink = /\/datav\/index\//.test(item.url);
        const url = islink ? unescape(item.url.split('datav/index/')[1]) : '#' + (item.url || "").toLowerCase();
        return (
            <a className={item.active ? "root-menu-active" : "root-menu-link"} href={url} onClick={(event) => {
                this.onMenuTab(item);
                this.expend(item.id);

                if (islink) {
                    window.location.hash = item.url;
                    event.preventDefault();
                }


            }}><span className={index === ((data.children || []).length - 1) ? "menu-line-last" : "menu-line"}></span>{
                    (item.children && item.children.length > 0) ? (item.expend ? <i className="fa fa-folder-open menu-item-type" aria-hidden="true"></i> : <i className="fa fa-folder menu-item-type" aria-hidden="true"></i>) : <i className="fa fa-table menu-item-type menu-item-table" aria-hidden="true"></i>
                }{item.name}<span className="root-menu-active-high"></span>
            </a>
        )
    }

    children(data) {
        return (
            <ul className={data.expend ? "root-menu-children-expend" : "root-menu-children-default"}>
                {
                    (data.children || []).map((item, index) => (
                        <li>

                            {(item.children && item.children.length > 0) ? <a href="javascript:;" className={item.active ? "root-menu-active" : "root-menu-link"} onClick={() => {
                                this.expend(item.id);
                            }}>
                                <span className={index === ((data.children || []).length - 1) ? "menu-line-last" : "menu-line"}>
                                    <Icon type={item.expend ? "minus-square-o" : "plus-square-o"} />
                                </span>{
                                    (item.children && item.children.length > 0) ? (item.expend ? <i className="fa fa-folder-open menu-item-type" aria-hidden="true"></i> : <i className="fa fa-folder menu-item-type" aria-hidden="true"></i>) : <i className="fa fa-table menu-item-type menu-item-table" aria-hidden="true"></i>
                                }{item.name}<span className="root-menu-active-high"></span></a> :
                                this.anchor(item, index, data)
                            }

                            {
                                item.children ? this.children(item) : ''
                            }
                        </li>
                    ))
                }
            </ul>
        )
    }

    getExpendTop(expend) {
        if (expend) {
            const top = (this.state.menu.length - 1) * 35 + 40;
            return {
                marginTop: -top,
                paddingTop: top
            };
        } else {
            return {
                marginTop: 0,
                paddingTop: 0
            }
        }
    }


    onMenuDraggable(x, y) {
        this.draggable = true;

        this.startOffset = [x, y];
        this.stopOffset = [x, y];

        this.props.onMenuDragStart();
    }



    render() {
        return (
            <div className={this.props.menuExpend ? "root-menu" : "root-menu root-menu-hide"} style={{ width: this.props.Offset[0] }}>
                <div className="root-menu-container">
                    <h1><label>功能菜单</label><Icon type="bars" onClick={this.props.onMenuExpend} /></h1>
                    {
                        this.state.menu.map((menu, i) => (
                            <div className={menu.expend === true ? "root-menu-section root-menu-expend" : "root-menu-section"} style={this.getExpendTop(menu.expend)}>
                                <h3 className={menu.active ? "root-menu-active" : "root-menu-defaults"} onClick={() => {
                                    this.expend(menu.id);
                                }}>
                                    <i className="fa fa-folder" /><span>{menu.name}</span>
                                    <Icon type={menu.expend ? "down" : "up"} /></h3>
                                <div className="root-menu-view">
                                    <div className="root-menu-scroll">
                                        {
                                            this.children(menu)
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="root-draggable"
                    onMouseDown={(event) => {
                        this.onMenuDraggable(event.pageX, event.pageY)
                    }} ref="draggable">
                    <i></i>
                </div>
            </div>
        )
    }
}